import { useState } from 'react';
import { useRequest as useRequestOfAHooks } from 'ahooks';

type IUseRequestOfAHooks<TData, TParams extends any[]> = typeof useRequestOfAHooks<TData, TParams>;

interface IUseRequestExtOptions {
  initialLoading?: boolean;
}

export default function useRequest<TData, TParams extends any[]>(
  service: Parameters<IUseRequestOfAHooks<TData, TParams>>[0],
  options?: Parameters<IUseRequestOfAHooks<TData, TParams>>[1],
  extOptions?: IUseRequestExtOptions,
): ReturnType<IUseRequestOfAHooks<TData, TParams>> {
  const { onBefore, onFinally, ...restOptions } = options || {};
  const { initialLoading = true } = extOptions || {};

  const [loading, setLoading] = useState(initialLoading);

  const res = useRequestOfAHooks<TData, TParams>(service, {
    ...restOptions,
    onBefore: (params: TParams) => {
      onBefore?.(params);
      if (!loading) {
        setLoading(true);
      }
    },
    onFinally: (error, data, params) => {
      onFinally?.(error, data, params);
      setLoading(false);
    },
  });

  return { ...res, loading };
}
